import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {
  httpOptions;
  httpBoday = '';
  tokenData;
  countrieValue;
  buid;
  customFieldId;
  pageIndex = 1
  pageSize = 10;
  constructor(private http: HttpClient) {
  }

  getValueOfPagination(pageIndex, pageSize) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize
  }

  getPaginationValue(pageIndex, pageSize) {
    // const pageSizes = pageSize * 10;
    // this.pageSize = pageSize;
    // if( pageSizes - 20 >= this.pageSize){
    //   this.pageSize = pageSizes;
    // }
    this.pageIndex = pageIndex;
  }

  getQuestions(): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.get<any>(ApiEndPoint.PreQuestions.all, this.httpOptions);
  }

  addPreQuestion(questionBody): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.post<any>(ApiEndPoint.PreQuestions.add, questionBody, this.httpOptions)
  }

  updatePreQuestion(questionBody): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.put<any>(ApiEndPoint.PreQuestions.update, questionBody, this.httpOptions);
  }

  deletePreQuestion(preQuestionBody): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.PreQuestions.delete, preQuestionBody, this.httpOptions);
  }

  updatePreQuestionGroup(questionGroupBody, qcat_id): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.put<any>(ApiEndPoint.PreQuestions.update + `/${qcat_id}`, questionGroupBody, this.httpOptions);
  }

  getPreQuestionGroups(): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.PreQuestions.groups, this.httpOptions);
  }

  deleteQuestionGroup(row): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.PreQuestions.update + `/${row.qcat_id}/delete`, { "qcatname": row.qcatname }, this.httpOptions);
  }
}

